import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CannabisShowCaseGridItem from "./CannabisShowCaseGridItem";

const CannabisShowCaseGrid = ({ handleOpenModal, data, restUrl }) => {
    return (
        <Fragment>
            {data.map(dataItem => {
                return (
                    <CannabisShowCaseGridItem
                        handleOpenModal={handleOpenModal}
                        dataItem={dataItem}
                        restUrl={restUrl}
                        key={dataItem.sku}
                    />
                );
            })}
        </Fragment>
    );
};

CannabisShowCaseGrid.defaultProps = {
    handleOpenModal: () => {},
    data: [],
    restUrl: ""
};

CannabisShowCaseGrid.propTypes = {
    handleOpenModal: PropTypes.func,
    data: PropTypes.array,
    restUrl: PropTypes.string
};

export default CannabisShowCaseGrid;
